import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetChecklistItemsAction } from '../../actions/checklist-items/get-checklist-items-action';
import { RemoveChecklistItemErrorAction } from '../../actions/checklist-items/remove-checklist-item-error-action';
import { RemoveChecklistItemAction } from '../../actions/checklist-items/remove-checklist-item-action';

@Injectable()
export class RemoveChecklistItemEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public AddGroup = createEffect(() => this.actions
    .pipe(
      ofType(RemoveChecklistItemAction.type),
      mergeMap(action => {
        const removeChecklistItemAction = <RemoveChecklistItemAction>action;
        return this.api.deleteChecklistItem(removeChecklistItemAction.checklistItem).then(() => {
          return new GetChecklistItemsAction(removeChecklistItemAction.bijbEvent);
        }, error => {
          return new RemoveChecklistItemErrorAction(error);
        });
      })
    ));
}
